import BookItem from "../common/bookItem";
import Sentence from "./sentence";
import EventBus from "../../event_bus";
//普通逐句朗讀
export default class SentenceGroup extends BookItem {
    sentences = [];
    recordchildren = [];
    constructor(el, target) {
        super(el, target);
        this.times = el.times;

        //測試用
        // this.times = "[00.56,02.07,02.87,05.56,05.96,08.13]"
    }

    init() {
        //紀錄有哪些段落在群組內
        for (let i = 0; i < this.target.children.length; i++) {
            if (this.target.children[i].sentence)
                this.recordchildren.push(this.target.children[i]);
        }

        this.times = this.times.replace(/\[*\]*/g, '').split(",").map(Number);

        //尋找頁面上所有段落並與紀錄對照，找出需要顯示的段落
        //找出後依照順序放置於陣列
        for (let i = 0; i < this.itemControl.bookItems.length; i++) {
            if (this.itemControl.bookItems[i] instanceof Sentence && this.recordchildren.includes(this.itemControl.bookItems[i].target)) {
                this.sentences[this.itemControl.bookItems[i].turn] = this.itemControl.bookItems[i];
            }
        }

        //避免順序中有漏數字，移除找到的空陣列
        this.sentences = this.sentences.filter(sentence => sentence != undefined);

    }

    trigger(audio) {
        //依照時間及順序顯示段落
        if (this.times.length != this.sentences.length * 2) {
            console.log("時間數量及段落數量不相等!");
            return;
        }

        EventBus.getInstance()._app.audioConfig.timeSteps = this.times;
        EventBus.getInstance().getAppRefs().soundManager.setDefaultAudioConfig(this.times);
        let self = this;
        let nowTimeIndex = -1;

        const showFunc = function () {
            // TIP : 看當下音檔時間超過哪個最相近時間的陣列index給timeindex，timeindex就是群組當前的第timeindex個要顯示黃色
            let timeindex = 0;

            for (let index = 0; index < self.times.length; index += 2) {
                if (audio.currentTime > 0 && audio.currentTime > self.times[index]) {
                    // TIP : 因為repeat功能關係所以要去判斷當前repeat時抓取正確的index顯示
                    if (audio.currentTime < self.times[index + 1]) {
                        timeindex = index;
                    }
                    else {
                        timeindex = index + 2;
                    }
                }
            }

            // TIP : 當前index跟原先的index值一樣 => 沒換下一句 => 不需做事return，需要就把當前值替換掉後做事
            if (nowTimeIndex == timeindex && audio.currentTime > 0) {
                return;
            }
            else {
                nowTimeIndex = timeindex;
            }

            // TIP : 全句子底色先關掉
            closeSentencesFunc();

            if(audio.currentTime == 0) {
                nowTimeIndex = -1;
                return;
            }

            // TIP : timeindex %2 是要抓群組設定黃底的開始時間，可參考an組件設定
            if (timeindex % 2 == 0) {
                self.sentences[nowTimeIndex / 2].target.gotoAndStop(0);
                self.sentences[nowTimeIndex / 2].isShow = true;
            }
            // console.table("self.sentences", self.sentences);

        }

        /**
         * 結束執行關掉所有句子底色及狀態及移除監聽
         */
        const endFunc = function () {
            closeSentencesFunc();
            audio.removeEventListener("timeupdate", showFunc);
            audio.removeEventListener("ended", endFunc);
        }

        /**
         * 關掉所有句子底色及狀態
         */
        const closeSentencesFunc = function () {
            self.sentences.map((x) => {
                x.sentence_gotoAndStop(1);
                x.isShow = false;
            });
        }

        // TIP : 音檔播完時會利用endFunc移除timeupdate
        audio.addEventListener("ended", endFunc);

        audio.addEventListener("timeupdate", showFunc);
        window.soundManager.setCallBackFunc(endFunc);
    }
}